import { type Document } from "./docs";

export type Role = "student" | "staff" | "instructor";
export const TrainingTypeArray = [
  "mandatory",
  "individual",
  "incumbent",
] as const;
export type TrainingType = (typeof TrainingTypeArray)[number];
export type Department = "life" | "pro";
export type Timetable = "weekends" | "weekdays" | "weekdays-b";
export type Course = "special" | "general";

export type Student = {
  id: number;
  status: "approved" | "rejected" | "";
  user_code: string;
  training_type: TrainingType;
  department: Department;
  course: Course;
  timetable: Timetable;
  name: string;
};

export type StudentDocs = Student & { docs: Record<string, Document> };

export type StudentProgress = Student & {
  progress: Record<string, any>;
  training_progress: Record<string, any>;
  total_status: string;
};

export const StatusSelectOptions = [
  { value: "empty", label: "채점 안 됨" },
  { value: "uploaded", label: "업로드됨" },
  { value: "approved", label: "승인" },
  { value: "rejected", label: "거절" },
];
